export class TipoContrato {
  idtipocontrato?: number;
  nombre?: string;
  editando?: boolean;
  constructor() {}
}
